import moment from 'moment';
import get from 'lodash/get';
import { DATE_FORMAT } from '../../constants';
import { numberToDecimal } from '../../utils/currency';

const messages = (locale, { data, payment }) => ({
  create: [
    {
      head: locale['common.paymentType'],
      value: payment.paymentType
    },
    {
      head: locale['common.payeeName'],
      value: get(payment, 'beneficiaryAccountInfo.accountName')
    },
    {
      head: locale['common.amount'],
      value: payment.creditAmount
        ? numberToDecimal(payment.creditAmount)
        : numberToDecimal(payment.amount)
    },
    {
      head: locale['common.transactionDate'],
      value: moment(payment.transactionDate).format(DATE_FORMAT)
    },
    {
      head: locale['common.remainingApproval'],
      value: payment.remainingApprovals
    },
    {
      head: locale['common.bankTrace'],
      value: payment.bankTrace
    }
  ],
  delete: [
    {
      head: locale['common.paymentType'],
      value: payment.paymentType
    },
    {
      head: locale['common.payeeName'],
      value: get(payment, 'beneficiaryAccountInfo.accountName')
    },
    {
      head: locale['common.amount'],
      value: payment.creditAmount
        ? numberToDecimal(payment.creditAmount)
        : numberToDecimal(payment.amount)
    }
  ],
  reject: [
    {
      head: locale['common.paymentType'],
      value: payment.paymentType
    },
    {
      head: locale['common.payeeName'],
      value: get(payment, 'beneficiaryAccountInfo.accountName')
    },
    {
      head: locale['common.amount'],
      value: payment.creditAmount
        ? numberToDecimal(payment.creditAmount)
        : numberToDecimal(payment.amount)
    },
    {
      head: locale['common.transactionDate'],
      value: moment(payment.transactionDt).format(DATE_FORMAT)
    }
  ],
  approve: [
    {
      head: locale['common.paymentType'],
      value: payment.paymentType
    },
    {
      head: locale['common.payeeName'],
      value: get(payment, 'beneficiaryAccountInfo.accountName')
    },
    {
      head: locale['common.amount'],
      value: payment.creditAmount
        ? numberToDecimal(payment.creditAmount)
        : numberToDecimal(payment.amount)
    },
    {
      head: locale['common.transactionDate'],
      value: moment(payment.transactionDt).format(DATE_FORMAT)
    },
    {
      head: locale['common.remainingApproval'],
      value: payment.remainingApprovals
    }
  ],
  modify: [
    {
      head: locale['create.payment.type'],
      value: payment.paymentType
    },
    {
      head: locale['create.payment.payeeName'],
      value: get(payment, 'beneficiaryAccountInfo.accountName')
    },
    {
      head: locale['create.payment.amount'],
      value: payment.creditAmount
        ? numberToDecimal(payment.creditAmount)
        : numberToDecimal(payment.amount)
    }
  ],
  template: [
    {
      head: locale['common.fromAccount'],
      value: data && data.originatingAccountInfo && data.originatingAccountInfo.accountName
    },
    {
      head: locale['common.beneficiaryName'],
      value: get(payment, 'beneficiaryAccountInfo.accountName')
    },
    {
      head: locale['common.templateName'],
      value: payment.templateName
    },
    {
      head: locale['common.paymentType'],
      value: payment.paymentType
    }
  ]
});

export const alertOk = (locale, { payment, paymentAction, title, extra = {} }) => {
  return {
    success: true,
    title,
    paymentAction,
    records: payment,
    details: messages(locale, { payment, ...extra })[paymentAction]
  };
};
